"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _profile = require("@/api/profile");

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lodash = _interopRequireDefault(require("lodash"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Secondary package based on el-pagination
var _default = {
  name: 'AdminNotice',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        title: '',
        type: 'unread',
        sort: 'add_time',
        order: 'desc'
      },
      multipleSelection: [],
      notice: {
        title: '',
        source: '',
        content: '',
        addTime: ''
      },
      noticeVisible: false
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    toTicketDetail: function toTicketDetail(row) {
      var _this = this;

      //查看工单详情 
      (0, _profile.readNoticeTicketNo)(row).then(function (res) {
        var ticketInfo = res.data.data;

        if (ticketInfo != undefined) {
          _this.$router.push({
            path: "/ticket/ticketDetail",
            query: {
              ticketId: ticketInfo.id,
              customerId: ticketInfo.customerId
            }
          });
        } else {
          _this.$message.error('无工单信息！');
        }
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;
      (0, _profile.listNotice)(this.listQuery).then(function (response) {
        _this2.list = response.data.data.list;
        _this2.total = response.data.data.total;
        _this2.listLoading = false;
      }).catch(function () {
        _this2.list = [];
        _this2.total = 0;
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      (0, _profile.rmNotice)(row).then(function (response) {
        _this3.$notify.success({
          title: '成功',
          message: '删除通知成功'
        });

        var index = _this3.list.indexOf(row);

        _this3.list.splice(index, 1);
      }).catch(function (response) {
        _this3.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this4 = this;

      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择至少一条记录');
        return;
      }

      var ids = [];

      _lodash.default.forEach(this.multipleSelection, function (item) {
        ids.push(item.id);
      });

      (0, _profile.brmNotice)({
        ids: ids
      }).then(function (response) {
        _this4.$notify.success({
          title: '成功',
          message: '批量删除通知成功'
        });

        _this4.getList();
      }).catch(function (response) {
        _this4.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    },
    handleRead: function handleRead(row) {
      var _this5 = this;

      (0, _profile.catNotice)(row).then(function (response) {
        _this5.notice = response.data.data;
        _this5.noticeVisible = true;
      });
    },
    afterRead: function afterRead() {
      this.noticeVisible = false;
      this.getList();
    },
    handleBatchRead: function handleBatchRead() {
      var _this6 = this;

      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择至少一条记录');
        return;
      }

      var ids = [];

      _lodash.default.forEach(this.multipleSelection, function (item) {
        ids.push(item.id);
      });

      (0, _profile.bcatNotice)({
        ids: ids
      }).then(function (response) {
        _this6.$notify.success({
          title: '成功',
          message: '批量设置通知已读成功'
        });

        _this6.getList();
      }).catch(function (response) {
        _this6.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    }
  }
};
exports.default = _default;